<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      @for (item of breadcrumbLinkList; track $index) {
        <li>
          <a [href]="item.link">
            @if (breadcrumbLinkList.indexOf(item) == 0) {
              <fa-icon [icon]="icons[root]" />
            }
            {{ item.description }}
          </a>
        </li>
      }
      <li>
        <a>
          @if (!breadcrumbLinkList?.length) {
            <fa-icon [icon]="icons[root]" />
          }
          {{ leafDescription }}
        </a>
      </li>
    </ul>
  </div>
  <ng-content select="[slot=toolbar]" />
</div>
<ng-content />
